import React from "react";
import HeroPage from "../ones/PageHero"; // Adjust path based on your file tree
import { 
  MdVerifiedUser, 
  MdFactCheck, 
  MdAssessment, 
  MdSecurity, 
  MdTerminal, 
  MdBookmark, 
  MdArrowForward 
} from "react-icons/md";
import CallToAction from "../ones/CallToAction";
import Footer from "../ones/Footer";

export default function AuditAssurance() {
  // Localization data passed directly to the shared HeroPage component
  const heroData = {
    kicker: "TRUSTED OVERSIGHT",
    title: "Rigorous Audit & Assurance Frameworks for Corporate Transparency",
    description: "Delivering independent financial auditing and robust assurance engagements aligned with NBAA mandates and international criteria to safeguard institutional integrity."
  };

  const capabilities = [
    {
      icon: <MdVerifiedUser />,
      title: "Statutory Audits",
      desc: "Comprehensive, independent examination of statutory financial registers ensuring total conformity with the Companies Act of Tanzania and NBAA accounting practices."
    },
    {
      icon: <MdFactCheck />,
      title: "Non-Statutory Audits",
      desc: "Tailored internal audit evaluations, operations checks, and custom target reviews designed for stakeholder specific needs or donor-funded project parameters."
    },
    {
      icon: <MdAssessment />,
      title: "Financial Reporting",
      desc: "Synthesis, validation, and advanced diagnostic reviews of corporate financial books to ensure reporting transparency across all corporate streams."
    },
    {
      icon: <MdSecurity />,
      title: "Assurance Engagements",
      desc: "Specialized risk assessment reports and evaluation frameworks deployed beyond standard audits to fortify corporate credit lines and stakeholder trust."
    },
    {
      icon: <MdBookmark />,
      title: "Accounting and Auditing Standards",
      desc: "Strict execution of ISA (International Standards on Auditing) backed directly by our mandatory team discussion updates every Friday morning."
    }
  ];

  return (
    <div className="service-details-page-wrapper">
      {/* SHARED HERO INVOCATION */}
      <HeroPage data={heroData} />

      {/* OVERVIEW SECTION */}
      <section className="service-overview-section py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-7" data-aos="fade-right">
              <span className="overview-kicker text-secondary text-uppercase font-weight-bold tracking-wider">Operational Review</span>
              <h2 className="overview-title text-primary font-weight-bold mt-2">Sustaining Compliance &amp; Institutional Trust</h2>
              <p className="overview-paragraph text-muted-narrative mt-3">
                As an active NBAA member firm, Blessing Management Consultancy executes rigorous audit oversight to give your enterprise absolute reporting clarity. Our methodologies help small, medium, and large-scale corporations track assets accurately and balance operational risk profiles with confidence.
              </p>
            </div>
            <div className="col-lg-5" data-aos="fade-left">
              <div className="overview-sidebar-card border p-4 rounded bg-white shadow-sm">
                <h4 className="text-primary font-weight-bold border-bottom pb-2 mb-3">Service Brief</h4>
                <ul className="sidebar-bullet-list list-unstyled d-flex flex-column gap-2 mb-0">
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>NBAA Public Practice Aligned</span></li>
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>Full ISA Standard Frameworks</span></li>
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>Fixed-Fee Pricing Transparency</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DETAILED CAPABILITIES GRID */}
      <section className="service-capabilities-section py-5 bg-light-surface-tint">
        <div className="container">
          <div className="section-title-area text-center mb-5" data-aos="fade-up">
            <h2 className="text-primary font-weight-bold">Core Scope of Operations</h2>
            <div className="kicker-line mx-auto bg-secondary mt-2" />
          </div>

          <div className="row g-4 justify-content-center">
            {capabilities.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="premium-capability-card h-100 bg-white p-4 border rounded shadow-sm d-flex flex-column">
                  <div className="capability-icon-box text-primary mb-3 fs-2">{item.icon}</div>
                  <h3 className="capability-title text-primary font-18 font-weight-bold mb-2">{item.title}</h3>
                  <p className="capability-desc text-muted mb-0 font-14 flex-grow-1">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* METHODOLOGY & CTA */}
      <section className="service-cta-banner bg-primary text-white text-center py-5">
        <div className="container py-3" data-aos="zoom-in">
          <h2 className="font-weight-bold mb-3">Need Independent Audit &amp; Assurance?</h2>
          <p className="max-w-600 mx-auto text-light-opacity mb-4">
            Protect your organization against institutional risk. Partner with our registered public practice firm today.
          </p>
          <button className="btn btn-secondary text-primary font-weight-bold px-4 py-2 border-0">
            Schedule Briefing <MdArrowForward className="ms-1" />
          </button>
        </div>
      </section>

      <CallToAction />
      <Footer />
    </div>
  );
}